import React, { useState } from "react";
import Modal from "../../../../parts/modal-new";
import TestModal from "./testModal";

const Modals = () => {
  const [openedModal, setOpenedModal] = useState(false);
  return (
    <div className="flex flex-col gap-2">
      <button data-button-type="secondary" onClick={() => setOpenedModal(true)}>
        Open by js/react
      </button>
      {openedModal && (
        <Modal title={"This is a test Modal"}>
          <div className="body w-80 h-80">
            <p>This is where the body goes</p>
          </div>
          <footer>
            <button
              data-button-type="secondary"
              data-action="cancel"
              onClick={() => setOpenedModal(false)}
            >
              Cancel
            </button>
            <button
              data-button-type="secondary"
              onClick={() => setOpenedModal(false)}
            >
              Save
            </button>
          </footer>
        </Modal>
      )}
      <a
        role="button"
        data-button-type="secondary"
        href="/actions/refresh?modal[type]=test-modal"
        className="w-fit"
      >
        Open by anchor
      </a>
    </div>
  );
};

export default Modals;
